/**
 * @description
 * This contains class and interface for show more details.
 */
import * as React from "react";
import IProps from "./IProps";
import { handleEnter, imagePathurl } from "../../../../../../utils/utils";
interface IState {
    formID: any;
    showMoreEnabled?: any;
    message?: any;
    imageSource?: any;
}
/**
 * @class ShowMoreDetails
 * @description This class will basically be used to show more details page
 * @category Widgets
 */
class ShowMoreDetails extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        const getimagePath = imagePathurl();
        this.state = {
            formID: "",
            showMoreEnabled: false,
            message: "Show more details",
            imageSource: `${getimagePath}review-down-red.png`,
        };
        this.onToggleShowMore = this.onToggleShowMore.bind(this);
    }

    /**
     * @function  onToggleShowMore
     * @description This function will be used to toggle show more or show less and will
     * also be used to show option to toggle with arrow image
     * @ignore
     */
    onToggleShowMore() {
        //image CDN_PATH
        const getimagePath = imagePathurl();
        if (this.state.showMoreEnabled) {
            this.setState({
                showMoreEnabled: false,
                message: "Show more details",
                imageSource: `${getimagePath}review-down-red.png`,
            });
        } else {
            this.setState({
                showMoreEnabled: true,
                message: "Show less details",
                imageSource: `${getimagePath}review-up-red.png`,
            });
        }
    }

    render() {
        const { showMoreObj, tabIndex } = this.props;
        const { showMoreEnabled, message, imageSource } = this.state;
        const showMoreContent = Object.keys(showMoreObj).map((item, index) => {
            let datanode = null;
            if (Array.isArray(showMoreObj[item])) {
                datanode = (
                    <span className="gaf-description-value column">
                        {showMoreObj[item].map((items, index) => (
                            <span key={`${item}-${index}`} className="display-block">
                                {items}
                            </span>
                        ))}
                    </span>
                );
            } else {
                datanode = showMoreObj[item] && (
                    <span className="gaf-description-value column">{showMoreObj[item]}</span>
                );
            }
            return (
                <div key={`${item}-index`} className="gaf-key-value-container row">
                    {showMoreObj[item] && <span className="gaf-description-key column"> {item}</span>}
                    {datanode}
                </div>
            );
        });

        /**
         * @return
         * @description : This is a pace where we check whether or not we have to display the more
         * details Object.
         */
        return (
            <div className="main-container">
                {showMoreEnabled && showMoreContent}
                <span
                    className="gaf-show-more-key gaf-show-more"
                    onClick={this.onToggleShowMore}
                    tabIndex={tabIndex}
                    onKeyPress={handleEnter}
                >
                    {message}
                    <img src={imageSource} alt="chevronDown" />
                </span>
            </div>
        );
    }
}
export default ShowMoreDetails;
